import { Stack, Tabs, Tab } from '@mui/material';
import {
  ScreenWrap,
  HeaderBreadcrumbs,
  SoloLoading,
  UserAccountDetails,
  ScreenError,
} from '../../components';
import UserDashboard from '../../components/UserDashboard';
import { useParams, useLocation, Link, Navigate } from 'react-router';
import { useTypedSelector } from '../../reducers';
import { Api } from '../../api';

export default function UserDetailsTabsScreen() {
  const { id } = useParams();
  if (!id) throw new Error('Reached UserDetailsTabsScreen without params.id');
  const location = useLocation();
  const { viewMode } = useTypedSelector((s) => s.auth);

  const isAdmin = viewMode === 'admin';
  const pathParts = location.pathname.split('/').filter(Boolean);
  const lastPart = pathParts[pathParts.length - 1];
  const adminTabs = [
    { label: 'Account Details', value: 'account-details' },
    { label: 'User Dashboard', value: 'user-dashboard' },
  ] as const;

  const currentTab = isAdmin
    ? adminTabs.some((t) => t.value === lastPart)
      ? lastPart
      : null
    : null;

  const apiUserStats = Api.UserStats.useReadItemStats(id);

  if (location.pathname === `/users/${id}`) {
    if (isAdmin) {
      return <Navigate to={`/users/${id}/account-details`} replace />;
    } else {
      return <Navigate to={`/users/${id}/user-dashboard`} replace />;
    }
  }

  if (apiUserStats.error) return <ScreenError {...apiUserStats} />;
  if (!apiUserStats.data) return <SoloLoading />;
  const userStats = apiUserStats.data;

  return (
    <ScreenWrap>
      <Stack spacing={3}>
        <HeaderBreadcrumbs
          title={`${isAdmin ? 'User' : 'Client'}: ${userStats.user.name ?? userStats.user.email}`}
          items={[{ name: 'Users', url: '/users' }]}
        />

        {isAdmin && (
          <Tabs
            value={currentTab || adminTabs[0].value}
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            {adminTabs.map((t) => (
              <Tab
                key={t.value}
                value={t.value}
                label={t.label}
                component={Link}
                to={`/users/${id}/${t.value}`}
              />
            ))}
          </Tabs>
        )}

        {(!isAdmin || currentTab === 'user-dashboard') && (
          <UserDashboard viewMode={viewMode} stats={userStats} />
        )}
        {isAdmin && currentTab === 'account-details' && (
          <UserAccountDetails
            stats={userStats}
            invalidate={apiUserStats.invalidate}
          />
        )}
      </Stack>
    </ScreenWrap>
  );
}
